interface LayoutProps {
  children: React.ReactNode;
}

export const Container: React.FC<LayoutProps> = ({ children }) => {
  return (
    <main className="relative flex-1 overflow-y-auto pb-8" id="app-content">
      {children}
    </main>
  );
};
